import { RunSnapshot, RunTraceRequest } from './runs';
import { DataFileRef, PlacedRun, placeRun } from './placement';
import { TableRow } from './types';

/**
 * Charts a report draws from the point files a run recorded, with nothing
 * known about the procedure: each file's first two columns, x against y.
 *
 * A step that recorded a picture (a scope screenshot) already shows its
 * waveform, so only the data files of steps with no picture of their own are
 * drawn — the "switch power and acquire the waveforms" step, not the
 * per-region captures — in print order, up to a limit: the server reads each
 * file for every view of the report.
 */

/** Points a data file's chart is drawn from: enough for a chart a page wide, little to freeze into a published version. */
export const DATA_FILE_CHART_POINTS = 400;
/** At most this many data files are drawn; the rest are listed in the appendix only. */
export const MAX_DATA_FILE_CHARTS = 12;

export const dataFileTraceKey = (fileId: string): string => `file:${fileId}`;

/** The data files a report draws, in print order. */
export function chartedDataFiles(placed: PlacedRun): DataFileRef[] {
  const blocks = [...placed.data, ...placed.validation, ...placed.analysis, ...placed.conclusion, ...placed.appendix.blocks];
  return blocks
    .filter((b) => b.figures.length === 0)
    .flatMap((b) => b.files.filter((f) => f.kind === 'data'))
    .slice(0, MAX_DATA_FILE_CHARTS);
}

/** What a report asks the server to read for its data-file charts (a definition's `traces`). */
export function dataFileTraces(run: RunSnapshot, sectionMap: TableRow[] = []): RunTraceRequest[] {
  return chartedDataFiles(placeRun(run, sectionMap)).map((f) => ({ key: dataFileTraceKey(f.fileId), fileId: f.fileId, points: DATA_FILE_CHART_POINTS }));
}
